export default "__VITE_ASSET__RXPUPDXI__"